import { ExpertiseValues } from 'enums/Expertise';
import MenteeForm from 'types/MenteeForm';

export type State = Required<
  Pick<
    MenteeForm,
    | 'jobSearch'
    | 'careerPlan'
    | 'studies'
    | 'entrepreneurship'
    | 'sharing'
    | 'volunteerState'
    | 'volunteerOrganism'
    | 'validatedDiploma'
    | 'completedFormation'
    | 'formationMatchingProject'
    | 'intendedFormation'
    | 'formationState'
    | 'intendedDiploma'
    | 'consideration'
    | 'hobby'
    | 'heardAboutMentorship'
    | 'heardAboutMentorshipText'
    | 'expectations'
    | 'sharingEmail'
    | 'sharingPhone'
  >
> & {
  expertises: ExpertiseValues[];
};

export type Errors = {
  priorityLevels: boolean;
  expertises: boolean;
  general: boolean;
  badRequest: boolean;
  permissions: boolean;
  expectations: boolean;
  volunteerOrganism: boolean;
};

export const initialErrors: Errors = {
  priorityLevels: false,
  expertises: false,
  general: false,
  badRequest: false,
  permissions: false,
  expectations: false,
  volunteerOrganism: false,
};
